<template>
    <div>
        <h2>
            Сайт: {{domain.domain_name}}
            <b-button :to="{name: 'domainEdit', params: {id: domain.id}}" size="sm">Редактировать</b-button>
            <b-button @click="deleteDomain" size="sm" variant="danger">Удалить</b-button>
        </h2>
        <div v-if="domain.description">
            Описание: {{domain.description}}
        </div>
        <div v-if="domain.propagation_url">
            Пересылка заявок: {{domain.propagation_url}}
        </div>

        <h3 class="mt-3">Список пользователей которым разрешен доступ к домену:</h3>
        <div v-if="!loaded">
            <font-awesome-icon icon="spinner" spin></font-awesome-icon>
        </div>
        <ul>
            <li v-for="user in users" :key="user.id">
                <b>{{user.username}}</b> ({{user.email}})
            </li>
        </ul>
        <h3 class="mt-3">Код для вставки на счетчика на ваш сайт:</h3>

        <textarea class="form-control" rows="20" readonly>
<script type='text/javascript'>
    (function (d, w, c) {
        (w[c] = w[c] || []).push(function () {
            w.driveCounter = new DriveCounterClass('{{domain.domain_hash}}');
            driveCounter.registerVisit();
        });

        var n = d.getElementsByTagName('script')[0],
            s = d.createElement('script'),
            f = function () {
                n.parentNode.insertBefore(s, n);
            };
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://drivecrm.ru/js/counter.js?v=1';

        if (w.opera === '[object Opera]') {
            d.addEventListener('DOMContentLoaded', f, false);
        } else {
            f();
        }
    })(document, window, 'drive_counter_callback');
</script></textarea>
        <h3>Укажите данный адрес для отправки заявок из Тильды:</h3>
        <input class="form-control" readonly value="https://drivecrm.ru/api/lead/tilda-save">

    </div>
</template>

<script>
    import DomainRepository from "../../repository/DomainRepository";
    import axios from "axios";

    export default {
        name: "DomainInfo",
        props: {
            domain: Object
        },
        data: function () {
            return {
                loaded: false,
                users: []
            }
        },
        methods: {
            deleteDomain() {
                if (confirm("Вы уверены, что хотите удалить данный сайт?")) {
                    DomainRepository.deleteDomain(this, this.domain.id).then(() => {
                        this.$router.push({name: 'domainIndex'})
                    });
                }
            },
            loadDomainInfo() {
                let app = this;
                app.loaded = false;
                app.users = [];
                axios.get('/api/domain/detail/' + this.domain.id)
                    .then(function (resp) {
                        app.users = resp.data.users;
                        app.loaded = true;
                    })
                    .catch(function () {
                        alert("Невозможно загрузить информацию о сайте");
                    });
            }
        },
        mounted() {
            console.log('mounted');
            this.loadDomainInfo();
        },
        watch: {
            domain() {
                console.log('domain changed');
                this.loadDomainInfo();
            }
        }
    }
</script>

<style scoped>

</style>